module.exports = __webpack_public_path__ + "static/media/baloes.21cbae05.png";